export type Granularity = 'daily' | 'weekly' | 'monthly';
export type ChartType = 'bar' | 'line';

export interface TimeSeriesPoint {
  period: string;
  count: number;
}

export interface ModuleTimeSeriesPoint {
  module: string;
  period: string;
  count: number;
}

export interface ModuleEventBreakdownPoint {
  module: string;
  period: string;
  event_name: string;
  count: number;
}

export interface TopUserPoint {
  user_email: string;
  user_name: string;
  count: number;
}

export interface AnalyticsModule {
  id: string;
  module_name: string;
  color: string;
  is_active: boolean;
  events: string[];
  payload_breakdown_fields: string[];
}

export interface PayloadBreakdownPoint {
  field_value: string;
  count: number;
}

export const GRANULARITY_OPTIONS: { label: string; value: Granularity }[] = [
  { label: 'Daily', value: 'daily' },
  { label: 'Weekly', value: 'weekly' },
  { label: 'Monthly', value: 'monthly' },
];

export const DAYS_OPTIONS: { label: string; value: number }[] = [
  { label: '7 days', value: 7 },
  { label: '30 days', value: 30 },
  { label: '90 days', value: 90 },
];
